export default function Marquee() {
  const items = [
    "FAMILY-OWNED",
    "★ 4.9 RATED",
    "ON-TIME GUARANTEE",
    "FLAT-RATE PRICING",
    "FREE ESTIMATES",
    "NO HIDDEN FEES",
    "KY · IN · OH · WV",
  ];
  const row = [...items, ...items];
  return (
    <div className="bg-[#5BB239] border-y border-[#499828] overflow-hidden py-4">
      <div className="flex ticker-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-8 pr-8">
            <span className="font-display font-black text-white text-lg tracking-tight">{t}</span>
            <span className="text-white/40">✱</span>
          </div>
        ))}
      </div>
    </div>
  );
}
